<template>
  <div v-if="hotSearchList.length">
    <ul class="hot-search" data-spm-d="d231">
      <li
        class="font-color-hover-primary"
        v-for="(item, index) in hotSearchList"
        :key="index"
        @click="clickHotSearch(item.word)">
        {{item.word}}
      </li>
    </ul>
  </div>
</template>

<script>
import Api from '../api.js'
import response from 'fe-coms/utils/response'
export default {
  name: 'hot-search',
  props: {},
  data () {
    return {
      isShowHotSearch: false,
      hotSearchList: []
    }
  },
  methods: {
    clickHotSearch (hot) {
      this.$router.push('/list?q=' + encodeURIComponent(hot) + '&_t=' + new Date().getTime() + '&currentActive=0')
    },
    /**
       * 获取搜索热词
       * @returns {Promise<void>}
       */
    async getHotSearchConfig () {
      let api = Api.hotSearchConfig
      let res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        // 0-启用， 1-不启用
        this.isShowHotSearch = res.content === '0'
        if (this.isShowHotSearch) {
          this.getHotSearch()
        }
      }
    },
    /**
       * 获取搜索热词
       * @returns {Promise<void>}
       */
    async getHotSearch () {
      let api = Api.hotSearch
      let res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        this.hotSearchList = res.content || []
      }
    }
  },
  created () {
    this.getHotSearchConfig()
  }
}
</script>

<style scoped lang="scss">
  .hot-search{
    li{
      display: inline-block;
      font-size: 12px;
      color: #636E95;
      margin-right: 16px;
      cursor: pointer;
    }
  }
</style>
